<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="号码分区名称">
              <a-input placeholder="请输入号码分区名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <!--          <a-col :md="6" :sm="8">-->
          <!--            <a-form-item label="号码算法类型">-->
          <!--              <a-select v-model="queryParam.algorithmType" placeholder="请选择算法类型">-->
          <!--                <a-select-option value="default">default</a-select-option>-->
          <!--              </a-select>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :md="6" :sm="8">
            <a-form-item label="号码类型">
              <a-select
                  show-search
                  v-model="queryParam.type"
                  placeholder="请选择号码类型"
                  style="width: 100%"
                  :filter-option="filterOption"
                  allowClear>
                <a-select-option v-for="option in numberTypeOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="号码规则">
              <a-select
                  show-search
                  v-model="queryParam.numberRuleId"
                  placeholder="请选择号码规则"
                  style="width: 100%"
                  :filter-option="filterOption"
                  allowClear>
                <a-select-option v-for="rule in numberTypeOptions" :key="rule.value" :value="rule.value">
                  {{ rule.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">搜索</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
          ref="table"
          bordered
          size="middle"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical"/>

          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>

      <!-- table区域-end -->
      <NumberRuleCreater ref="modalForm" @ok="modalFormOk"></NumberRuleCreater>
    </div>

  </a-card>
</template>

<script>
import NumberRuleCreater from './modules/NumberRuleCreater'
import {TableListMixin} from '@/situation/mixins/tableListMixin'
import {deleteNumberInterval} from '@/api/numberInterval'
import {mapGetters} from 'vuex'

export default {
  name: "NumberRuleList",
  mixins: [TableListMixin],
  components: {
    NumberRuleCreater
  },
  computed: {
    ...mapGetters(["numberTypeOptions"]),
  },
  data() {
    return {
      description: '这是号码规则管理页面',
      queryParam: {},
      columns: [
        {
          title: "号码分区名称",
          align: "center",
          dataIndex: 'name',
          width: 150
        },
        // {
        //   title: "号码算法类型",
        //   align: "center",
        //   width: 120,
        //   dataIndex: 'algorithmType',
        // },
        {
          title: "号码类型",
          align: "center",
          width: 100,
          dataIndex: 'type',
          customRender: (text) => {
            const option = this.numberTypeOptions.find(item => item.value === text);
            return option ? option.label : text;
          }
        },
        {
          title: "最小值",
          align: "center",
          width: 100,
          dataIndex: 'valueMin'
        },
        {
          title: "最大值",
          align: "center",
          width: 100,
          dataIndex: 'valueMax'
        },
        {
          title: "当前值",
          align: "center",
          width: 100,
          dataIndex: 'currentValue'
        },
        {
          title: "号码前缀",
          align: "center",
          width: 100,
          dataIndex: 'prefix'
        },
        {
          title: "号码后缀",
          align: "center",
          width: 100,
          dataIndex: 'suffix'
        },
        {
          title: "数据长度",
          align: "center",
          width: 80,
          dataIndex: 'numberDigits'
        },
        {
          title: "创建时间",
          align: "center",
          width: 150,
          dataIndex: 'createTime'
        },
        {
          title: "操作",
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'},
          align: "center",
          width: 100
        }

      ],
      url: {
        selectData: "/ndt/numberInterval/page",
        deleteData: "/ndt/numberInterval/delete"
      },
      selectedRowKeys: []
    }
  },
  mounted() {
    this.$store.dispatch('GetNumberTypeOptions');
  },
  methods: {
    // 下拉框过滤方法
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleAdd() {
      this.$refs.modalForm.add();
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record);
    },
    handleDelete(id) {
      this.loading = true;
      deleteNumberInterval(id).then(res => {
        if (res.code) {
          this.$message.success('删除成功');
          this.loadData();
        } else {
          this.$message.error(res.msg || '删除失败');
        }
      }).catch(error => {
        console.error('删除失败:', error);
        this.$message.error('删除失败，请稍后重试');
      }).finally(() => {
        this.loading = false;
      });
    },
    modalFormOk() {
      this.loadData();
    }
  }

}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
